import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

function ProductCategory() {

  const [showModal, setShowModal] = React.useState(false);

  const [cardData] = useState([
    {
      name: 'Shisha',
      path: '../printer'
    },
    {
      name: 'Burger'
    },
    {
      name: 'Sweet'
    },
    {
      name: 'Pakage 28'
    },
    {
      name: 'Pakage 15'
    },
    {
      name: 'Pakage 19'
    },
  ])


  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div>

          <button className=" mt-2 bg-[#7B20C7] text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"><Link>Download Driver From Thermal Printer</Link></button>
          <button className=" mt-2 bg-[#7B20C7] text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"><Link to="../printer">Category Printer</Link></button>

        </div>

        <div>
          <h1 className="text-[#7B20C7] text-2xl font-semibold pt-5">Products</h1>
          <p className="text-xs py-2">Note: Before assigning products please download client machine to allow RMS to read your system printers. Download Link JSPM
            Click on three dots menu to assign printers on product level. To assign printers on category level click on category printers button above here all category will display click on three dots to assign printers.</p>
        </div>
        <div className="flex flex-wrap gap-6">
          {cardData &&
            cardData.map((data) => (

              <div className="border-solid border-2 border-[#7B20C7] cursor-pointer rounded-2xl w-36 hover:transition-all hover:bg-[#7B20C7] group ">

                <span className="flex justify-end p-1 px-2 " onClick={() => setShowModal(true)}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512" className="fill-[#7B20C7] group-hover:fill-white " height="18"><path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" /></svg>
                </span>

                <Link to={data.path}>
                  <h1 className="flex justify-center align-middle   text-md font-semibold group-hover:text-white ">{data.name}</h1>
                  <div className="flex justify-end p-1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512" className="fill-orange-500 " height="16" width='30'><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" /></svg>
                  </div>
                </Link>
              </div>

            ))}
        </div>




        {
          showModal ? (
            <>
              <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative mx-auto w-1/3">
                  {/*content*/}
                  <div className="border-0 rounded-lg shadow-lg relative flex flex-col  bg-white outline-none focus:outline-none overflow-y-auto shiftmodel">
                    {/*header*/}
                    <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">

                      <h1 className="text-xl text-[#7B20C7]">Select Printer by Category</h1>
                      <button
                        className=" ml-auto  float-right text-2xl" onClick={() => setShowModal(false)} >
                        <span className="text-[#7B20C7]"> × </span>
                      </button>
                    </div>
                    <div className="p-4">

                      Old Printer Name
                    </div><hr className="min-h-0.5  w-auto mx-2" />
                    {/*body*/}
                    <div className="relative px-4 text-start ">


                      <label className="text-sm font-semibold">sandwish</label>

                      <div>
                        <Select
                          type="text"
                          placeholder="Select Item"
                          className="   placeholder-blueGray-300 text-blueGray-600 relative rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                          required
                        />
                      </div>
                    </div>

                    <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">

                      <button
                        className="text-[#7B20C7]  text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                        type="submit" onClick={() => setShowModal(false)}
                      >
                        Close</button>

                      <button
                        className="text-[#7B20C7] text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                        type="submit"
                      >
                        Save Changes</button>


                    </div>
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
          ) : null
        }
      </div>
    </main>

  );
}

export default ProductCategory;